/** @jsxImportSource @emotion/react */
import CloseIcon from "@mui/icons-material/Close";
import { css, Dialog, DialogActions, IconButton } from "@mui/material";
import { t } from "i18next";
import { VFC } from "react";
import { AiOutlineWarning } from "react-icons/ai";
import Button from "../common/Button";

interface Props {
  open: boolean;
  handleClose: () => void;
  goToConfirmStep: () => void;
}

const DateValidationModal: VFC<Props> = (props: Props) => {
  return (
    <Dialog
      open={props.open}
      onClose={props.handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      maxWidth="xs"
      fullWidth
    >
      <div className="p-4">
        <div style={{ textAlign: "right" }}>
          <IconButton onClick={props.handleClose}>
            <CloseIcon />
          </IconButton>
        </div>
        <div className="text-base whitespace-pre-line text-black pt-4 pb-4">
          {t("create_press_release.modal.date_validation.description")}
          <div css={dialogCaution}>
            <AiOutlineWarning size="28px" style={{ marginRight: 8 }} />
            {t("create_press_release.modal.save.caution")}
          </div>
        </div>
        <DialogActions>
          <Button
            text={t("create_press_release.modal.button.cancel")}
            onClick={props.handleClose}
          />
          <Button
            text={t("create_press_release.modal.button.ok")}
            onClick={() => {
              props.goToConfirmStep();
              props.handleClose();
            }}
          />
        </DialogActions>
      </div>
    </Dialog>
  );
};

const dialogCaution = css`
  display: flex;
  font-size: 14px;
  align-items: center;
  margin-top: 12px;
  color: #808080;
`;

export default DateValidationModal;
